export default function tabsPostProcessor(res) {
  const counts = res.aggregations ? res.aggregations.aggCounts.buckets : []
  counts.push({key: 'All', doc_count: counts.reduce((a, c) => a + c.doc_count, 0)})

  return counts
}
